import { jsx as _jsx } from "react/jsx-runtime";
import BaseIcon from "../../BaseIcon";
var Icon = function (_a) {
    var className = _a.className;
    return (_jsx(BaseIcon, { className: className, viewBox: "0 0 300 300", children: _jsx("path", { d: "M198.2,100.3L45,245.3l9.3,9.8l153.1-144.9L198.2,100.3z M57.9,50l-17.5,96h94.3l22.2-21l41-38.8l21.6,22.8l0.9,0.9l-1.2,1.2l-37,35l-35.2,33.3L133,255h96.5L267,50H57.9z" }) }));
};
export default Icon;
